import { db, auth, portalAuth } from '../config/Firebase';

const usersRef = db.collection("users")

export const getUserByEmail = async (email) => {
    return await usersRef.doc(email).get()
}

export const getAllUsers = async () => {
    const snap = await usersRef.get()
    return snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
}

export const loginMailAndPassword = (mail, password) => {
    return auth
        .signInWithEmailAndPassword(mail, password).then(userInfo => {
            return userInfo.user
        })
        .catch(error => {
            throw error
        })
}

export const signOut = () => {
    return auth.signOut()
}

export const createAppUser = async (email, password, userData) => {
    await portalAuth.createUserWithEmailAndPassword(email, password)
    await portalAuth.signOut()
    await usersRef.doc(email).set({
        role: userData.role || 'admin',
        displayName: userData.displayName || '',
        permissions: userData.permissions || null,
    })
}

export const updateUserFirestoreDoc = async (email, data) => {
    await usersRef.doc(email).set(data, { merge: true })
}

export const changeUserPassword = async (email, newPassword) => {
    const { functions } = await import('../config/Firebase')
    const fn = functions.httpsCallable('changeUserPassword')
    await fn({ email, newPassword })
}
